export const TYPE = {
  ORDER: 'order',
  RFQ: 'rfq'
};
TYPE.values = Object.keys(TYPE).map(t => TYPE[t]);

const RECORD_ID_FIELDS = {
  order: 'OrderNumber',
  rfq: 'RFQNumber'
};

export const ORDER_STATUS = {
  CANCELLED: 'Cancelled',
  EXECUTED: 'Executed',
  EXPIRED: 'Expired',
  WORKING: 'Working'
};
ORDER_STATUS.values = Object.keys(ORDER_STATUS).map(status => ORDER_STATUS[status]);

export const RFQ_STATUS = {
  ACCEPTED: 'Accepted',
  EXECUTED: 'Executed',
  PROVIDED: 'Provided',
  RECEIVED: 'Received',
  PASSED: 'Passed'
};
RFQ_STATUS.values = Object.keys(RFQ_STATUS).map(status => RFQ_STATUS[status]);

export function getRecordId(type, record) {
  return record[RECORD_ID_FIELDS[type]];
}

export const GROUP = {
  CORPORATE: 'CORPORATE',
  FIN_INSTITUTE: 'FIN_INSTITUTE'
};

export const FILTER_PARAM = {
  CLIENT: 'clientIds',
  INSTRUMENT: 'instrumentTypeIds',
  ORDER_STATUS: 'orderStatuses',
  RFQ_STATUS: 'rfqStatuses',
  SALES_PERSON: 'salesIds',
  START_DATE: 'startDate',
  END_DATE: 'endDate'
};
FILTER_PARAM.values = Object.keys(FILTER_PARAM).map(f => FILTER_PARAM[f]);



// WEBPACK FOOTER //
// ./src/utility/types.js